module.exports = __webpack_public_path__ + "static/media/GPG601A_F01_LB.1f0ab9d6.jpg";